import store from './index';
import getUserAdsList from '@/api/get-user-ads';
import getUserDetail from '@/api/get-user-detail';
import {
  getPayInfoList,
  getUserAsset,
  getUserCommunitySettings,
  getResumeAdsStatus,
  setUserDefaultCurrency,
  getStatistics,
  getInviteCode,
} from '@/api/user';

export const userInfoState = {
  isLogin: false,
  userInfo: getDefaultUserInfo(),
  appToken: '',
  kycInfo:{
    status: '',
    message: '',
  },
  payInfoList: [],
  myAdsList: [],
  hasResumeAds: false,
  userAssets: [],
  communitySettings: {
    loadStatus: 'pending',
    assets: [],
    choose: [],
    property: 0,
  },
  userStatistics: {
    total: '0',
    totalBuy: '0',
    totalSell: '0',
    assetIds: [],
  },
};

export const userInfoMutations = {
  setUserInfo(state, obj) {
    if (obj.isLogin !== undefined) {
      if (!obj.isLogin) {
        state.isLogin = false;
        state.myAdsList = [];
        state.userAssets = [];
        state.appToken = '';
        state.communitySettings = {
          loadStatus: 'pending',
          assets: [],
          choose: [],
          property: 0,
        };
        state.userStatistics = {
          total: '0',
          totalBuy: '0',
          totalSell: '0',
        };
        const lang = state.userInfo.lang;
        const langMain = state.userInfo.langMain;
        state.userInfo = Object.assign(getDefaultUserInfo(), {
          lang,
          langMain,
        });
        store.commit('clearLocalUserInfo');
        return;
      } else {
        state.isLogin = true;
        delete obj.isLogin;
      }
    }
    Object.assign(state.userInfo, obj);
    state.userInfo.updateAt = new Date().getTime();
    store.commit('saveUserInfoToLocal');
  },
  setKycInfo(state, obj) {
    Object.assign(state.kycInfo, obj);
  },
  setOtcPayInfo(state, obj) {
    Object.assign(state.otcPayInfo, obj);
  },
  loadUserInfoFromLocal() {
    const str = window.localStorage.getItem('userInfo');
    if (!str) return;
    try {
      const obj = JSON.parse(str);
      // 有token才认为已登录
      if (obj.token) {
        obj.isLogin = true;
      }
      store.commit('setUserInfo', obj);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(e);
    }
  },
  saveUserInfoToLocal(state) {
    const str = JSON.stringify(state.userInfo);
    window.localStorage.setItem('userInfo', str);
    // 单独存一个key 方便获取
    window.localStorage.setItem('userInfoUpdateAt', state.userInfo.updateAt);
    window.localStorage.setItem('appToken', state.userInfo.token);
  },
  clearLocalUserInfo() {
    window.localStorage.clear();
  },
  setMyAdsList(state, obj) {
    state.myAdsList = obj.list;
  },
  setPayInfo(state, list) {
    state.payInfoList = list;
  },
  removePayInfoItem(state, id) {
    const targetIndex = state.payInfoList.findIndex(item => item.id == id);
    if (targetIndex > -1) {
      state.payInfoList.splice(targetIndex, 1);
    }
  },
  setUserAsset(state, obj) {
    const index = state.userAssets.findIndex(
      item => item.assetId == obj.assetId,
    );
    if (index > -1) {
      state.userAssets[index].balance = obj.balance;
    } else {
      state.userAssets.push(obj);
    }
  },
  setCommunitySettings(state, obj) {
    Object.assign(state.communitySettings, obj);
  },
  setHasResumeAds(state, status) {
    state.hasResumeAds = status;
  },
  setUserStatistic(state, obj) {
    Object.assign(state.userStatistics, obj);
  },
};

export const userInfoActions = {
  updateUserInfo({ commit, state }) {
    return getUserDetail(state.env.conversationId)
      .then(data => {
        const d = data.data;
        commit('setUserInfo', {
          id: d.id,
          nickname: d.nickname,
          trueName: d.trueName,
          avatar: d.avatarUrl,
          createdAt: d.createdAt * 1000,
          hasCertified: d.isLandun, // 蓝盾认证
          hasVerified: !!d.trueName, // 通过实名认证
          advKycLevel: d.advKycLevel, //高级认证状态 0,默认暂时不需要，1，已认证； -1，触发需要认证，-2 触发第二次认证
          videoKycLevel: d.videoKycLevel,
          advertisementRate: d.rate && d.rate.advertisementRate,
          responseRate: d.rate && d.rate.responseRate,
          mixinId: d.mixinID,
          phone: d.phone,
          hasPayMethods: !!+d.hasPayMethods, // 绑定了支付方式
          isMerchant: !!+d.isMerchant, // 是商家，允许绑定多种支付方式
          isOwner: !!+d.isGroupOwner, // 是群主
          defaultLegalCurrencyId: d.defaultLegalCurrencyId, // 法币首选项
          isOversea: !!+d.isOversea,
          inviter: d.inviter,
          hasTraded: d.isTrace,
          isReadGuide: !!+d.isReadGuide,
        });
        return Promise.resolve(data);
      })
      .catch(err => Promise.reject(err));
  },
  updateMyAdsList({ commit, state }) {
    return getUserAdsList()
      .then(data => {
        const list = [];
        const d = data.data;
        if (Array.isArray(d)) {
          d.forEach(item => {
            list.push({
              id: item.id, // 订单id
              type: item.type,
              title: item.title,
              description: item.description,
              status: item.status,
              attribute: item.attribute,
              // price
              price: item.price,
              minPrice: item.minPrice,
              maxPrice: item.maxPrice,
              // asset
              assetId: item.assetId,
              legalCurrencyId: item.legalCurrencyId,
              locationId: item.locationId,
              payMethodIds: Array.isArray(item.payMethodIds) ? item.payMethodIds : [],
              // asset: {
              //   name: item.asset.name,
              //   symbol: item.asset.symbol,
              //   iconUrl: item.asset.iconUrl,
              // },
              // legalCurrency: {
              //   name: item.legalCurrency.name,
              //   symbol: item.legalCurrency.symbol,
              // },
              // location: {
              //   name: item.location.name,
              // },
              // payMethods: Array.isArray(item.payMethods)
              //   ? item.payMethods.map(payMethod => {
              //     return {
              //       name: payMethod.name,
              //     };
              //   })
              //   : [],
              user: {
                nickname: item.user.nickname,
                avatarUrl: item.user.avatarUrl,
                createdAt: item.user.createdAt,
                multisigOrderCount: item.user.multisigOrderCount,
                hasCertified: !!+item.user.isLandun || state.userInfo.hasCertified,
                hasVerified: !!item.user.trueName,
                orderSuccessRank: item.user.orderSuccessRank,
                rateRank: item.user.rateRank,
                in5minRate: item.user.in5minRate,
              },
              zone: item.zone,
              ontimeStart: item.ontimeStart,
              ontimeEnd: item.ontimeEnd,
              isCheck: !!+item.isCheck,
            });
          });
        }
        commit('setMyAdsList', { list });
        return Promise.resolve(data);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  },
  updatePayInfo({ commit }) {
    return getPayInfoList().then(data => {
      const d = data.data;
      const list = [];
      if (Array.isArray(d) && d.length) {
        d.forEach(item => {
          list.push({
            id: item.id,
            method: item.symbol,
            // fromExinOne: Boolean(+item.isExinone),
            trueName: item.content.truename,
            account: item.content.account,
            qr: item.content.qr ? item.content.qr : null,
            address1: item.content.name || '',
            address2: item.content.address || '',
            isDefault: !!+item.isDefault,
            isShow: !!+item.isShow,
          });
        });
      }
      commit('setPayInfo', list);
    });
  },
  updateUserAsset({ commit }, assetId) {
    return getUserAsset(assetId)
      .then(data => {
        const d = data.data;
        commit('setUserAsset', {
          assetId: assetId,
          balance: d.balance,
        });
      })
      .catch(err => Promise.reject(err));
  },
  updateUserCommunitySettings({ commit, state }) {
    return getUserCommunitySettings(state.env.conversationId)
      .then(data => {
        const d = data.data;
        commit('setCommunitySettings', {
          assets: d.assets.map(item => {
            return {
              id: item.id,
              icon: item.icon_url,
              name: item.name,
            };
          }),
          choose: d.chooseAssets.map(item => {
            return {
              id: item.id,
              icon: item.icon_url,
              name: item.name,
            };
          }),
          property: d.property,
          loadStatus: 'success',
        });
      })
      .catch(err => {
        commit('setCommunitySettings', {
          assets: [],
          choose: [],
          property: 0,
          loadStatus: 'failed',
        });
        return Promise.reject(err);
      });
  },
  updateResumeAdsStatus({ commit }) {
    return getResumeAdsStatus()
      .then(data => {
        commit('setHasResumeAds', data.data.hasResume);
      })
      .catch(err => Promise.reject(err));
  },
  updateUserCurrency({ commit }, currencyId) {
    return setUserDefaultCurrency(currencyId).then(() => {
      commit('setUserInfo', { defaultLegalCurrencyId: currencyId });
    });
  },
  updateUserStatistics({ commit }) {
    return getStatistics()
      .then(data => {
        const d = data.data;
        commit('setUserStatistic', {
          total: d.total || 0,
          totalBuy: d.totalBuy || 0,
          totalSell: d.totalSell || 0,
          assetIds: Array.isArray(d.assetIds) ? d.assetIds : [],
        });
      })
      .catch(err => Promise.reject(err));
  },
  updateUserInviteInfo({ commit }) {
    return getInviteCode().then(({ data: d }) => {
      commit('setUserInfo', {
        inviteCode: d.code,
        userInviteRate: d.userRate,
        userGroupInviteRate: d.groupRate,
        inviteeRate: d.inviteeRate,
        inviteeCount: d.inviteeCount,
      });
    });
  },
};

function getDefaultUserInfo() {
  return {
    id: '-',
    nickname: '',
    phone: '',
    avatar: require('@/images/avatar-default.svg'),
    token: '',
    tokenExpiresAt: 0,
    lang: '',
    langMain: '',
    createdAt: '',
    hasCertified: false, // 蓝盾商家
    hasVerified: false, // 实名认证
    isMerchant: false, // 已经认证过的商家 允许添加多种支付方式
    isOwner: false, // 是否是对应的群主
    hasPayMethods: false,
    responseRate: null,
    advertisementRate: null,
    updateAt: 0,
    defaultLegalCurrencyId: '',
    inviteCode: '',
    userInviteRate: '', // 邀请返佣比例
    userGroupInviteRate: '', // 群组返佣比例
    inviteeRate: '', // 好友返佣比例
    inviteeCount: 0, // 邀请人数
    isOversea: false, // 是否是海外用户
    inviter: null, // 邀请人
    hasTraded: false, // 是否成功交易
    isReadGuide: false, // 是否阅读过新手引导
  };
}
